import { ErrorBoundary } from "@ant-design/pro-components";
import { Outlet } from "react-router-dom";
const GluceraLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </div>
  );
};

export default GluceraLayout;
